var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AdyenAdapter } from '../adapters/AdyenAdapter';
import { BraintreeAdapter } from '../adapters/BraintreeAdapter';
import { SupportedVendors } from '../common/Constants';
export var GooglePayButtonColor;
(function (GooglePayButtonColor) {
    GooglePayButtonColor["BLACK"] = "black";
    GooglePayButtonColor["WHITE"] = "white";
})(GooglePayButtonColor || (GooglePayButtonColor = {}));
/**
 * Represents a set of callbacks for payment form events.
 * @typedef {Object} PaymentFormCallbacks
 * @property {function} [onBrandImage] - Callback triggered when the brand image URL is available. Undefined if the brand image is not available or could not be determined.
 * @param {string} brandImageUrl - The URL of the brand image, provided by the vendor.
 * @returns {void}
 *
 * @property {function} [onCreditCardFormValidated] - Callback triggered when the credit card form is validated.
 * @param {CreditCardAuthorizedPayload} data - The credit card form fields data.
 * @returns {void}
 *
 * @property {function} [onCreditCardFormInvalidated] - Callback triggered when the credit card form is invalidated (was previously valid).
 * @returns {void}
 *
 * @property {function} [onSubmitForm] - Callback triggered when a request is made to submit the payment form.
 * @returns {void}
 */
export var FocusedField;
(function (FocusedField) {
    FocusedField[FocusedField["CARD_NUMBER"] = 0] = "CARD_NUMBER";
    FocusedField[FocusedField["EXPIRY_DATE"] = 1] = "EXPIRY_DATE";
    FocusedField[FocusedField["SECURITY_CODE"] = 2] = "SECURITY_CODE";
})(FocusedField || (FocusedField = {}));
/**
 * List of the current supported payment methods
 * @typedef {enum} SupportedPaymentMethods
 * @readonly
 * @enum {SupportedPaymentMethods}
 */
export var SupportedPaymentMethods;
(function (SupportedPaymentMethods) {
    SupportedPaymentMethods["WEB_DROP_IN_CREDIT_CARD"] = "webDropInCreditCard";
    SupportedPaymentMethods["WEB_DROP_IN_GOOGLE_PAY"] = "webDropInGooglePay";
    SupportedPaymentMethods["WEB_DROP_IN_PAYPAL"] = "webDropInPaypal";
})(SupportedPaymentMethods || (SupportedPaymentMethods = {}));
export var SupportedPaymentMethodMappings;
(function (SupportedPaymentMethodMappings) {
    SupportedPaymentMethodMappings["webDropInCreditCard"] = "creditCard";
    SupportedPaymentMethodMappings["webDropInGooglePay"] = "googlePay";
    SupportedPaymentMethodMappings["webDropInPaypal"] = "paypal";
})(SupportedPaymentMethodMappings || (SupportedPaymentMethodMappings = {}));
/**
 * Represents a session of an application, created by BillingGatewayService and should be used to perform
 * context-aware operations on the payment form.
 */
var ApplicationSession = /** @class */ (function () {
    function ApplicationSession(billingGatewayService, vendorName, applicationSessionConfig, locale, callbacks) {
        this.GetPaymentAdapter = function (billingGatewayService, config, callbacks) {
            if (config.vendorName === SupportedVendors.adyen) {
                return new AdyenAdapter(config, billingGatewayService, callbacks);
            }
            else if (config.vendorName === SupportedVendors.braintree) {
                return new BraintreeAdapter(config, billingGatewayService, callbacks);
            }
            else {
                throw new Error("Unsupported vendorName received: ".concat(config.vendorName));
            }
        };
        this.config = __assign(__assign({}, applicationSessionConfig), { locale: locale, getSelectedPaymentMethod: this.getSelectedPaymentMethod.bind(this), vendorName: vendorName });
        this.billingGatewayService = billingGatewayService;
        this.onPaymentSuccess = callbacks.onPaymentSuccess;
        this.onPaymentFailure = callbacks.onPaymentFailure;
        this.onProcessing = callbacks.onProcessing;
        this.setErrorDetails = callbacks.setErrorDetails;
        this.vendor = vendorName;
        this.vendorPaymentAdapter = this.GetPaymentAdapter(this.billingGatewayService, this.config, callbacks);
        this._paymentMethod = null;
    }
    ApplicationSession.prototype.initializeCreditCard = function (formRef, callbacks, cardFieldStyling, supportedCardBrands, onInitialized) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!formRef.current) {
                    return [2 /*return*/];
                }
                this.vendorPaymentAdapter.initializeCreditCard(formRef, callbacks, cardFieldStyling, supportedCardBrands, onInitialized);
                return [2 /*return*/];
            });
        });
    };
    /**
     * Since the credit card field component is dynamically loaded according to locale,
     * the Adyen component should be remounted when locale changes.
     * @param locale - required locale parameter. defaults to Locale.US in case it's undefined
     */
    ApplicationSession.prototype.remountCreditCardForm = function (locale) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // FIXME: replace 'en-US' with Locale.US
                // currently, there is a bug where a Javascript error occurs when using Locale.US
                // need to fix that issue first, then replace Locale.US
                this.vendorPaymentAdapter.remountCreditCardForm(locale || 'en-US');
                return [2 /*return*/];
            });
        });
    };
    ApplicationSession.prototype.initializeGooglePay = function (formRef, buttonColor, callback, onProcessing, onAuthorized, isGooglePayAvailable) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                if (!((_a = this.config.paymentMethods.googlePay) === null || _a === void 0 ? void 0 : _a.configuration) || !formRef.current) {
                    return [2 /*return*/];
                }
                this.vendorPaymentAdapter.initializeGooglePay(formRef, this.config.paymentMethods.googlePay, buttonColor, callback, onProcessing, onAuthorized, isGooglePayAvailable);
                return [2 /*return*/];
            });
        });
    };
    ApplicationSession.prototype.initializePayPal = function (formRef, callback, onShopperDetails, isPayPalAvailable, locale) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                if (!((_a = this.config.paymentMethods.paypal) === null || _a === void 0 ? void 0 : _a.configuration) || !formRef.current) {
                    return [2 /*return*/];
                }
                this.vendorPaymentAdapter.initializePayPal(formRef, this.config.paymentMethods.paypal, callback, onShopperDetails, isPayPalAvailable, locale);
                return [2 /*return*/];
            });
        });
    };
    ApplicationSession.prototype.submitPaymentForm = function (paymentInformation, threedsActionContainer, setErrorDetails, actionCallback) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!(threedsActionContainer === null || threedsActionContainer === void 0 ? void 0 : threedsActionContainer.current)) {
                    return [2 /*return*/];
                }
                this._paymentMethod = SupportedPaymentMethodMappings[paymentInformation.paymentType];
                if (!this._paymentMethod) {
                    throw new Error('No payment method selected');
                }
                this.vendorPaymentAdapter.submitPaymentForm(this.config, paymentInformation, threedsActionContainer, setErrorDetails, actionCallback, this.onPaymentSuccess, this.onPaymentFailure);
                return [2 /*return*/];
            });
        });
    };
    ApplicationSession.prototype.isApplePaySupported = function () {
        //TODO: Uncomment the section below when apple pay is implemented.
        // This prevents ugly/unusable UX from leaking to a production environment.
        return false;
        //return this.config.paymentMethods?.applePay !== undefined;
    };
    ApplicationSession.prototype.isGooglePaySupported = function () {
        var _a;
        // Remove application of GPay CDN, will be shifting the responsibility to the consumer.
        return !!((_a = this.config.paymentMethods) === null || _a === void 0 ? void 0 : _a.googlePay);
    };
    ApplicationSession.prototype.isPaypalSupported = function () {
        var _a, _b;
        return ((_b = (_a = this.config.paymentMethods) === null || _a === void 0 ? void 0 : _a.paypal) === null || _b === void 0 ? void 0 : _b.configuration) !== undefined;
    };
    ApplicationSession.prototype.areExpressPayOptionsAvailable = function () {
        return this.isApplePaySupported() || this.isGooglePaySupported() || this.isPaypalSupported();
    };
    ApplicationSession.prototype.getSupportedCardBrands = function () {
        return this.config.supportedCardBrands;
    };
    ApplicationSession.prototype.getSelectedPaymentMethod = function () {
        return this._paymentMethod;
    };
    return ApplicationSession;
}());
export { ApplicationSession };
